import * as React from 'react';
import { Switch } from 'antd';
import { FeatureDisplayWrapper } from '../feature-display-wrapper/feature-display-wrapper';
import { WebBadge } from '../badges/web-badge';
import { NativeIosBadge } from '../badges/native-ios-badge';
import { NativeAndroidBadge } from '../badges/native-android-badge';
import { DeliveryChannel } from '../../enums/delivery-channels';
var FragmentWrapper = function FragmentWrapper(_) {
  return _.children;
};
export var ChannelSwitch = function ChannelSwitch(props) {
  var _props$label;
  var value = props.value,
    disabled = props.disabled,
    disabledToggle = props.disabledToggle,
    disabledMessage = props.disabledMessage,
    _onChange = props.onChange,
    channel = props.channel,
    className = props.className,
    iconOptions = props.iconOptions;
  var defaultLabelText = props.shortLabelText ? DeliveryChannel.getShortName(channel) : DeliveryChannel.getLongName(channel);
  var label = (_props$label = props.label) !== null && _props$label !== void 0 ? _props$label : defaultLabelText;
  var showIcon = iconOptions === null || iconOptions === void 0 ? void 0 : iconOptions.showIcon;
  var DisplayWrapper = disabled ? FeatureDisplayWrapper : FragmentWrapper;
  var icon;
  if (showIcon) {
    switch (channel) {
      case DeliveryChannel.WEB:
        if (showIcon) {
          icon = /*#__PURE__*/React.createElement(WebBadge, null);
        }
        break;
      case DeliveryChannel.NATIVE_IOS:
        if (showIcon) {
          icon = /*#__PURE__*/React.createElement(NativeIosBadge, null);
        }
        break;
      case DeliveryChannel.NATIVE_ANDROID:
        if (showIcon) {
          icon = /*#__PURE__*/React.createElement(NativeAndroidBadge, null);
        }
        break;
      default:
        break;
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "channel-selector-item ".concat(channel.toLowerCase(), "-selector ").concat(className !== null && className !== void 0 ? className : '')
  }, /*#__PURE__*/React.createElement(DisplayWrapper, {
    type: 'tooltip',
    forwardProps: {
      title: disabledMessage !== null && disabledMessage !== void 0 ? disabledMessage : 'To enable this selection please contact your Account Manager.'
    }
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Switch, {
    checked: value.includes(channel),
    size: "small",
    onChange: function onChange(enabled) {
      var chIdx = value.indexOf(channel);
      if (enabled && chIdx === -1) {
        value.push(channel);
      } else {
        if (chIdx !== -1) {
          value.splice(chIdx, 1);
        }
      }
      if (!disabledToggle) {
        _onChange(value);
      }
    },
    disabled: disabled
  }), /*#__PURE__*/React.createElement("span", {
    className: "channel-selector-label"
  }, icon, !props.hideLabelText && /*#__PURE__*/React.createElement("span", {
    className: "channel-selector-label-text"
  }, "\xA0", label)))));
};